import { defineProductDimensions, frRccwPricingVersionDimension, frRccwSelectedDimension } from '@orus.eu/dimensions'

import { frRccwProductVersionDimension } from './fr-rccw-dimensions.ts'
import { frRccwQuoteDimension } from './fr-rccw-quote-dimension.ts'

export * from './fr-rccw-activity-dimensions.ts'
export * from './fr-rccw-allowed-cities-dimension.ts'
export * from './fr-rccw-claims-history-dimension.ts'
export * from './fr-rccw-dimensions.ts'
export * from './fr-rccw-driver-dimensions.ts'
export * from './fr-rccw-exclusions.ts'
export * from './fr-rccw-fee-dimensions.ts'
export * from './fr-rccw-formula-premiums-dimension.ts'
export * from './fr-rccw-policy-item-dimensions.ts'
export * from './fr-rccw-quote-dimension.ts'
export * from './fr-rccw-subscription-ui.ts'
export * from './rcc-ui-elements.ts'
export * from './fr-rccw-vehicle-dimensions.ts'

export const frRccwDimensionsModule = defineProductDimensions({
  product: 'fr-rccw',
  family: null,
  selectionDimension: frRccwSelectedDimension,
  productVersionDimension: frRccwProductVersionDimension,
  pricingVersionDimension: frRccwPricingVersionDimension,
  quoteV3Dimension: frRccwQuoteDimension,
})
